import {XH} from '@xh/hoist/core';
import moment from 'moment';

export function getDefaultOptions() {
    return {
        timeout: XH.getConf('apiTimeout'),
        headers: {'Content-Type': 'application/json'}
    };
}

/**
 * @param {(string|number|LocalDate)} dateTimeStr - timestamp in UTC
 * @returns {?Date} - parsed Date, or null if empty or invalid input.
 */
export function parseDateTime(dateTimeStr) {
    let parsedMoment;
    parsedMoment = dateTimeStr ? moment.parseZone(dateTimeStr) : null;
    return parsedMoment?.isValid() ? parsedMoment.toDate() : null;
}

export function asServerException(exception) {
    console.log(exception);
    if (exception.error?.message) {
        return {message: exception.error.message, details: exception.error};
    }
    return {message: exception};
}
